import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
export function LastChance() {
  return <section className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-123">
      <div className="absolute inset-0 bg-stadium-glow opacity-80 pointer-events-none" data-id="element-124"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-125">
        <div className="max-w-3xl mx-auto text-center" data-id="element-126">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-127">
            <h2 className="font-anton text-5xl md:text-6xl text-white uppercase tracking-wide mb-8" data-id="element-128">
              LAST CHANCE
            </h2>

            <div className="prose prose-lg prose-invert mx-auto text-gray-300 mb-12" data-id="element-129">
              <p className="text-xl font-medium text-white" data-id="element-130">
                Your players deserve the best version of you.
              </p>
              <p data-id="element-131">Not a coach improvising every practice.</p>
              <p data-id="element-132">
                Stop spending evenings searching for drills.
                <br data-id="element-133" />
                Stop building practices from scratch.
                <br data-id="element-134" />
                Stop guessing what to coach next.
              </p>
              <p className="text-xl text-gold-400 font-medium mt-6" data-id="element-135">
                Take control of your season with a complete coaching system
                designed to save time, reduce stress, and develop better
                basketball players.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-navy-950 border border-navy-700 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-136">
            <h3 className="font-anton text-3xl md:text-4xl text-white uppercase tracking-wide mb-2" data-id="element-137">
              BASKETBALL READY SYSTEM 365
            </h3>
            <p className="font-oswald text-xl text-gold-500 uppercase tracking-widest mb-8" data-id="element-138">
              6 Complete Volumes + 5 Premium Bonuses
            </p>

            <div className="mb-8" data-id="element-139">
              <div className="text-gray-400 font-oswald text-lg line-through mb-1" data-id="element-140">
                Regular Price: USD 97
              </div>
              <div className="text-gold-500 font-oswald text-xl uppercase tracking-widest mb-1" data-id="element-141">
                Today Only:
              </div>
              <div className="font-anton text-6xl text-white tracking-wider" data-id="element-142">
                USD 27
              </div>
            </div>

            <div className="flex flex-col items-center gap-6" data-id="element-143">
              <Button size="xl" fullWidth onClick={() => {
              ;
              (window as any).fbq?.('track', 'InitiateCheckout', {
                value: 27,
                currency: 'USD'
              });
              window.location.href = 'https://football-ready-system-365.impultienda.ar/checkout';
            }} data-id="element-144">
                YES, I WANT BASKETBALL READY NOW
              </Button>

              <div className="text-green-400 font-medium" data-id="element-145">
                Instant Access — Delivered By Email
              </div>

              <div className="flex flex-col items-center gap-3" data-id="element-146">
                <div className="flex items-center gap-1" data-id="element-147">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-148" />)}
                  <span className="ml-2 font-oswald text-lg text-gray-200" data-id="element-149">
                    4.9/5 — Verified Reviews
                  </span>
                </div>

                <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-150">
                  <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-151" />
                  <span data-id="element-152">7-Day Money Back Guarantee — Zero Risk</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}